/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const OidcExchangeTokenResponseR = t.interface({});

// optional attributes
const OidcExchangeTokenResponseO = t.partial({
  requiresOtpFlow: t.boolean,

  sessionToken: t.string
});

export const OidcExchangeTokenResponse = t.intersection(
  [OidcExchangeTokenResponseR, OidcExchangeTokenResponseO],
  "OidcExchangeTokenResponse"
);

export type OidcExchangeTokenResponse = t.TypeOf<
  typeof OidcExchangeTokenResponse
>;
